
    const data = {"name":"src/core/icons/pagination-dots","data":{"viewBox":"0 0 8 2","data":"<path pid=\"0\" d=\"M2.24 1c0 .556-.445 1-1 1-.556 0-1-.444-1-1s.444-1 1-1c.555 0 1 .444 1 1Zm5.333 0c0 .556-.444 1-1 1-.555 0-1-.444-1-1s.445-1 1-1c.556 0 1 .444 1 1Z\" _fill=\"#BBB\"/>","originalColors":[{"type":"fill","color":"#BBB"}],"stopColors":[]}}

            export default data
            